export default {
  init() {
    // JavaScript to be fired on all pages
  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
    $(".flexnav").flexNav();
  },
};



// WEBPACK FOOTER //
// resources/assets/scripts/routes/common.js